import { ReactNode } from 'react'

interface ModalBodyProps {
    children: ReactNode
}

function ModalHeader({ children }: ModalBodyProps) {
    return <div className='px-4 py-3'>{children}</div>
}

export default ModalHeader
